import styled from 'styled-components';
import { SvgIcon } from '@insly/qmt-reactjs-ui-lib';

export const UploaderDocumentsString = styled.div`
  ${({ theme }) => theme.text.normal};
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 24px;
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.strokeB};
  }
`;

export const UploaderDocuments = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 104px;
  background-color: #F0F0F0;
  border-radius: ${({ theme }) => theme.borderRadius};
  cursor: pointer;
  &:hover {
    background-color: #E8E8E8;
  }
  &.drag-over {
    background-color: ${({ theme }) => theme.colors.primary};
    ${UploaderDocumentsString} {
      border-right: none;
      color: ${({ theme }) => theme.colors.white};
      &:last-child {
        display: none;
      }
    }
  }
`;

export const UploaderDocumentsIcon = styled(SvgIcon)<{ margin?: string }>`
  width: 24px;
  height: 24px;
  stroke: currentColor;
  margin-left: ${({ margin }) => margin === 'left' ? '16px' : null};
  margin-right: ${({ margin }) => margin === 'right' ? '16px' : null};
`;
